import { withStyles } from '@material-ui/core';
import { styles } from './styles';
import { TournamentPhases as TournamentPhasesComponent } from './TounamentPhases.component';

export const TournamentPhases = withStyles(styles)(TournamentPhasesComponent)